const scrollbarSize = () => {
  const div = document.createElement("div");
  div.style.width = "100px";
  div.style.height = "100px";
  div.style.overflow = "scroll";
  div.style.position = "absolute";
  div.style.top = "-9999px";
  document.body.appendChild(div);

  const size = div.offsetWidth - div.clientWidth;

  document.body.removeChild(div);

  return size;
};

const slugize = (string) => {
  const letters = {
    ą: "a",
    ć: "c",
    ę: "e",
    ł: "l",
    ń: "n",
    ó: "o",
    ś: "s",
    ź: "z",
    ż: "z",
  };

  return string
    .toLowerCase()
    .replace(/[ąćęłńóśźż]/g, (match) => letters[match])
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
};

const cleanSlug = (slug) => (slug ? slug.replace(/-\d+$/, "") : undefined);

const parseDate = (date) => {
  if (!date) return undefined;

  const array = date.split(".");

  return `${array[0]} ${getMonth(array[1])} ${array[2]}`;
};

const getMonth = (string) => {
  switch (string) {
    case "01":
      return "January";
    case "02":
      return "February";
    case "03":
      return "March";
    case "04":
      return "April";
    case "05":
      return "May";
    case "06":
      return "June";
    case "07":
      return "July";
    case "08":
      return "August";
    case "09":
      return "September";
    case "10":
      return "October";
    case "11":
      return "November";
    case "12":
      return "December";
    default:
      return undefined;
  }
};

const getMedia = (media) =>
  media
    ? {
        gatsbyImage: media?.image?.gatsbyImage,
        videoUrl:
          media?.video?.file?.localFile?.publicURL ??
          media?.video?.localFile?.publicURL,
      }
    : {};

const shuffleArray = (array) => {
  if (!(array?.length > 0)) return undefined;

  let shuffled = array.slice();

  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));

    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  return shuffled;
};

const paginateElements = (elements, perPage) => {
  if (!Array.isArray(elements) || !(elements?.length > 0)) return [];

  if (typeof perPage !== "number" || perPage <= 1) return [elements];

  const totalPages = Math.ceil(elements.length / perPage);
  const paginated = [];

  for (let i = 0; i < totalPages; i++) {
    const start = i * perPage;
    const end = start + perPage;
    paginated.push(elements.slice(start, end));
  }

  return paginated;
};

const parseDomain = (url) => {
  try {
    const parsedUrl = new URL(url);

    return parsedUrl.hostname;
  } catch {
    return null;
  }
};

const applyStylesToUsercentrics = (hasBilberryWidget) => {
  const shadowHost = document.querySelector("#usercentrics-root");

  if (shadowHost && shadowHost.shadowRoot) {
    const button = shadowHost.shadowRoot.querySelector(
      'button[aria-label="Open Privacy Settings"]'
    );

    if (button) {
      if (
        window.matchMedia("(max-width: 959px)").matches &&
        hasBilberryWidget
      ) {
        button.style.setProperty("bottom", "86px", "important");
      } else {
        button.style.setProperty("bottom", "24px", "important");
      }

      button.style.setProperty("left", "24px", "important");
    }
  }
};

const applyStylesToBilberry = () => {
  const shadowHost = document.querySelector("bilberry-booking-widget");

  if (shadowHost && shadowHost.shadowRoot) {
    const rootBox = shadowHost.shadowRoot.querySelector(
      ".MuiPaper-root > .MuiBox-root"
    );
    const button = shadowHost.shadowRoot.querySelector(
      ".MuiPaper-root > button"
    );

    if (rootBox) {
      rootBox.style.setProperty(
        "max-height",
        "calc(100vh - 200px)",
        "important"
      );
    }

    if (button) {
      button.addEventListener("click", (e) => {
        const aria = e.currentTarget.getAttribute("aria-label");
        const usercentrics = document.querySelector("#usercentrics-root");

        if (usercentrics) {
          if (aria === "Open booking window") {
            usercentrics.style.display = "none";
          } else {
            usercentrics.style.display = "";
          }
        }
      });
    }
  }
};

const validateEmail = (email) => {
  const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

  return regex.test(email);
};

const parseLanguageCode = (code) => {
  const lowerCase = code.toLowerCase();

  switch (lowerCase) {
    case "nb":
      return "no";
    default:
      return "en";
  }
};

const getLanguageFromPath = (pathname) => {
  if (pathname.startsWith("/no/")) return "no";

  return "en";
};

export {
  scrollbarSize,
  slugize,
  cleanSlug,
  parseDate,
  getMedia,
  shuffleArray,
  paginateElements,
  parseDomain,
  applyStylesToUsercentrics,
  applyStylesToBilberry,
  validateEmail,
  parseLanguageCode,
  getLanguageFromPath,
};
